import React from 'react';
import { Space } from 'antd';
import client from '@/lib/feathers';
import EditSubjects from './components/EditSubjects';
import CreateRecordDialog from './components/CreateRecordDialog';
import AmountFilter from './components/AmountFilter';
import SubjectFilter from './components/SubjectFilter';
import TradeDateFilter from './components/TradeDateFilter';
import TradeTypeFilter from './components/TradeTypeFilter';
import DownloadFinanceSheet from './components/DownloadFinanceSheet/index';

const accountingSubjects = client.service('accountingSubjects');

export default function FinanceCommunityFunc({
  setIsUpdate,
  subjects,
  nestedSubjects,
  setFilter,
}) {
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Space style={{ display: 'flex', flexWrap: 'wrap' }}>
        <CreateRecordDialog {...{ nestedSubjects, setIsUpdate }} />
        <EditSubjects
          {...{ accountingSubjects, subjects, setIsUpdate, nestedSubjects }}
        />
        <DownloadFinanceSheet {...{ nestedSubjects }} />
      </Space>
      <Space>
        <TradeDateFilter {...{ setFilter }} />
        <TradeTypeFilter {...{ setFilter }} />
        <SubjectFilter {...{ nestedSubjects, setFilter }} />
        <AmountFilter {...{ setFilter }} />
      </Space>
    </Space>
  );
}
